/* eslint-disable */
/**
 * Modified version of "human-time" (https://github.com/bahamas10/human)
 * This version can optionally not append a suffix.
 */
/**
 * Print a human readable timestamp to the terminal
 * given a number representing seconds
 *
 * Author: Dave Eddy <dave@daveeddy.com>
 * Date: 8/18/2014
 * License: MIT
 */

export default (seconds, showSuffix = false) => {
    if (seconds instanceof Date) {
        seconds = Math.round((Date.now() - seconds) / 1000);
    }
    const suffix = seconds < 0 ? 'from now' : 'ago';
    seconds = Math.abs(seconds);

    const times = [
        seconds / 60 / 60 / 24 / 365, // years
        seconds / 60 / 60 / 24 / 30, // months
        seconds / 60 / 60 / 24 / 7, // weeks
        seconds / 60 / 60 / 24, // days
        seconds / 60 / 60, // hours
        seconds / 60, // minutes
        seconds, // seconds
    ];
    const names = ['year', 'month', 'week', 'day', 'hour', 'min', 'sec'];

    for (let i = 0; i < names.length; i++) {
        const time = Math.floor(times[i]);

        if (time >= 1) {
            const isPlural = time > 1;
            return `${time} ${names[i]}${isPlural ? 's' : ''}${showSuffix ? ` ${suffix}` : ''}`;
        }
    }

    return 'Just now';
};
